import { render } from "./EC.vue?vue&type=template&id=01359b53"
import script from "./EC.vue?vue&type=script&lang=js"
export * from "./EC.vue?vue&type=script&lang=js"
script.render = render

export default script